<template xmlns="">
  <div class="entertainmentdetail">
    <div class="left col-md-8 float-left pl-0">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="/">Trang chủ</a></li>
          <li class="breadcrumb-item"><a href="/giai-tri">Giải trí</a></li>
          <li class="breadcrumb-item active text-left" aria-current="page">{{ detail.title }}</li>
        </ol>
      </nav>
      <div class="title text-left">
        <h1 class="font-size-22 color-blue font-weight-bold">{{ detail.title }}</h1>
      </div>
      <div class="post-created text-left">
        <p class="color-gray">
          <span class="fa fa-calendar"> {{ detail.createdat }}</span>
        </p>
      </div>
      <div class="description text-justify">
        <h4 class="font-size-16 font-weight-bold mb-3">{{ detail.description }}</h4>
      </div>

      <div id="player"></div>

      <div class="content text-justify mt-5">
        <div v-html="detail.content"></div>
      </div>

      <same-category :list-news="listNewsSameCategory"></same-category>
    </div>
    <div class="right col-md-4 float-right pr-0">
      <music-top></music-top>
      <most-singer class="mt-5"></most-singer>
      <div class="ads" v-for="item in adv">
        <a :href="item.link">
          <img :src="item.image"/>
        </a>
      </div>
    </div>
    <div style="clear: both;"></div>
    <partner class="mt-5"></partner>
  </div>
</template>

<script>
  import SameCategory from './SameCategory'
  import MusicTop from '../../home/web/MusicTop'
  import MostSinger from '../../home/web/MostSinger'
  import Partner from '../../home/web/Partner'

  export default {
    name: "EntertainmentDetail",
    components: {
      "same-category": SameCategory,
      "music-top": MusicTop,
      "most-singer": MostSinger,
      "partner": Partner
    },
    data () {
      return {
        detail: {},
        listNewsSameCategory: null,
        adv: []
      }
    },
    created () {
      this.detail =
        {
          filePath: "http://localhost:8787/dmz/UploadFiles/20200615/_CungDanVoDoi-ChiPu.mp3",
        }
      ;
    },
    mounted () {
    },
    methods: {
      getNewsDetail(){
        axios.post(api.newsDetail, { id: this.$route.params.id })
          .then(response => {
            var res = response.data.result;
            res.forEach(item => {
              this.detail =
                {
                  title: item.title,
                  description: item.description,
                  createdat: item.createdat,
                  content: item.content,
                  audiopath: item.audiopath,
                  sameCategory: item.sameCategory
                };
            });
            return this.detail;
          })
          .then(response => {
            /*var player = jwplayer("player");
            player.setup({
              "file": response.audiopath,
              "width": "100%",
              "height": "30",
              "autostart": "true"
            });*/
            this.listNewsSameCategory = response.sameCategory;
            //console.log(this.listNewsSameCategory);
          })
          .catch(e => {
            console.log("Entertainment detail----");
            console.log(e);
          })
      },
      getAdv(){
        this.adv = [];
        axios.post(api.adv)
          .then(response => {
            var res = response.data.result;
            res.forEach(item => {
              if(item.page == "entertainment" && item.position == 1){
                this.adv.push(item);
              }
            });
          })
          .catch(e => {

          });
      }
    },
    watch: {
      "$route.params.id": {
        handler: function(val){
          this.getNewsDetail();
          this.getAdv();
        },
        immediate: true
      }
    }
  }
</script>

<style scoped>
  .content img{
    display: block;
    margin: 0 auto;
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .breadcrumb .active{
    display: inline-block;
    width: 60%;
    white-space: nowrap;
    overflow: hidden !important;
    text-overflow: ellipsis;
  }
  .right{
    margin-top: -15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/entertainmentdetail/web/EntertainmentDetail.vue